import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Replenishments.frontend.types'

@Injectable({ providedIn: 'root' })
export class Replenishments_create_location_replenishment_threshold_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { locationId: number, materialId: number, minimumPackagedAmount: number, minimumPackagingId: number, replenishmentPackagedAmount: number, replenishmentPackagingId: number, maximumPackagedAmount?: number, maximumPackingId?: number, onDemand?: boolean, systemTriggered?: boolean, comparisonTypeId?: number }): Promise<{ reasons?: string[], locationReplenishmentId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.locationId)) {
      missingRequiredInParams.push('\'locationId\'');
    }
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.minimumPackagedAmount)) {
      missingRequiredInParams.push('\'minimumPackagedAmount\'');
    }
    if (isNil(inParams.minimumPackagingId)) {
      missingRequiredInParams.push('\'minimumPackagingId\'');
    }
    if (isNil(inParams.replenishmentPackagedAmount)) {
      missingRequiredInParams.push('\'replenishmentPackagedAmount\'');
    }
    if (isNil(inParams.replenishmentPackagingId)) {
      missingRequiredInParams.push('\'replenishmentPackagingId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Replenishments/functions/create_location_replenishment_threshold_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

